exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2HWZlV4_aPJsqTWuxsODlS{color:#f50;float:right;font-weight:100;font-size:20px}._1oX5VL2_BK70ZEGw3cZRAF{font-size:30px;font-weight:100}._1MY7mOQpWGw6j_Xl4cCYpa{background-color:#f9f9f9;border-bottom:1px solid #fff;padding:60px 0 0;margin-top:30px}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/templates/Event/ListPrices/style.css"],"names":[],"mappings":"AAAA,yBACI,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,cAAgB,CACnB,AACD,yBACI,eAAgB,AAChB,eAAiB,CACpB,AACD,yBACI,yBAA0B,AAC1B,6BAA8B,AAC9B,iBAAoB,AACpB,eAAiB,CACpB","file":"style.css","sourcesContent":[".price {\n    color: #f50;\n    float: right;\n    font-weight: 100;\n    font-size: 20px;\n}\n.title {\n    font-size: 30px;\n    font-weight: 100;\n}\n.bgGrey {\n    background-color: #f9f9f9;\n    border-bottom: 1px solid #fff;\n    padding: 60px 0 0 0;\n    margin-top: 30px;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"price": "_2HWZlV4_aPJsqTWuxsODlS",
	"title": "_1oX5VL2_BK70ZEGw3cZRAF",
	"bgGrey": "_1MY7mOQpWGw6j_Xl4cCYpa"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/templates/Event/ListPrices/style.css
// module id = 983
// module chunks = 0 1 2 3